import { ChangeEvent, FocusEvent, KeyboardEvent } from "react";

import { InputProps } from "rivals/components/shared/Form/Input/types";

export enum InputType {
  PASSWORD = "password",
  TEXT = "text",
  DATE = "date",
  NUMBER = "number"
}

export interface OwnProps extends InputProps {
  /** Indicates that the input should be focused on page load */
  autofocus?: boolean;
  /** Initial value */
  defaultValue?: string | number;
  /** Whether the input is disabled */
  disabled?: boolean;
  /** Unique identifier of input */
  id?: string;
  /** Maximum length (number of characters) of value */
  maxLength?: number;
  /** Called when the input has lost focus */
  onBlur?: (e: FocusEvent<HTMLInputElement>) => void;
  /** Called when the input value changes */
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  /** Called when the input is in focus */
  onFocus?: (e: FocusEvent<HTMLInputElement>) => void;
  /** Called when a key is pressed down */
  onKeyDown?: (e: KeyboardEvent<HTMLInputElement>) => void;
  /** Placeholder of the input */
  placeholder?: string;
  /** The value is not editable */
  readOnly?: boolean;
  /** A value is required or must be checked for the form to be submittable */
  required?: boolean;
  /** Type of input */
  type: InputType;
  /** The initial value of the control */
  value?: string | number;
}
